'use client';
import NewsletterConfirmation from '@/components/NewsletterConfirmation';
import NewsletterConfirmationError from '@/components/NewsletterConfirmationError';
import { useSearchParams } from 'react-router-dom';

const NewsletterConfirm = () => {
  const [searchParams] = useSearchParams();

  const status = searchParams.get('status');

  if (status === 'success') return <NewsletterConfirmation />;
  
  return <NewsletterConfirmationError />;
};

export default NewsletterConfirm;
